import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type ILoader = {
  fullScreen?: boolean;
};

const Loader: React.FC<ILoader> = ({ fullScreen }): JSX.Element => {
  return (
    <>
      {fullScreen ? (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: "1000",
          }}
        >
          <CircularProgress
            sx={{ transform: "translate(-50%, -50%)", position: "absolute", left: "50%", top: "50%" }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: "1000",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};
export default Loader;